import React from 'react';
import Icon from '@ant-design/icons';

type IconProps = React.ComponentProps<typeof Icon>;

const IconComponent = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <defs>
      <path
        d="M-1.77635684e-15,11.9885825 C-1.77635684e-15,18.6096937 5.36747113,23.9771648 11.9885823,23.9771648 C18.6096935,23.9771648 23.9771646,18.6096937 23.9771646,11.9885825 C23.9771646,7.70547451 21.6921538,3.74771951 17.9828735,1.6061655 C14.2735932,-0.535388501 9.7035714,-0.535388501 5.9942911,1.6061655 C2.2850108,3.74771951 -1.77635684e-15,7.70547451 -1.77635684e-15,11.9885825 Z"
        id="faucet1"
      ></path>
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-20.000000, -481.000000)">
        <g transform="translate(20.022233, 481.000000)">
          <mask fill="white">
            <use xlinkHref="#faucet1"></use>
          </mask>
          <use fill="#3B3B43" fillRule="nonzero" xlinkHref="#faucet1"></use>
          <g mask="url(#mask-2)" fill="#FFFFFF">
            <g transform="translate(6.000000, 5.000000)">
              <circle fillRule="evenodd" cx="5.80362656" cy="10.9624057" r="1"></circle>
              <circle fillRule="evenodd" cx="3.65413524" cy="10.9624057" r="1"></circle>
              <circle fillRule="evenodd" cx="3.65413524" cy="12.6819988" r="1"></circle>
              <circle fillRule="evenodd" cx="1.07474566" cy="12.6819988" r="1"></circle>
              <circle fillRule="evenodd" cx="3.65413524" cy="14.4015918" r="1"></circle>
              <circle fillRule="evenodd" cx="1.50464392" cy="10.9624057" r="1"></circle>
              <circle fillRule="evenodd" cx="6.66342309" cy="12.6819988" r="1"></circle>
              <circle fillRule="evenodd" cx="7.09332135" cy="14.4015918" r="1"></circle>
              <circle fillRule="evenodd" cx="0.644847396" cy="14.4015918" r="1"></circle>
              <path
                d="M4.86816794,6.97074705 L6.42697904,6.97074705 L11.8350992,6.97074705 L17.9993625,6.97074705 L17.9993625,4.57255426 L11.8032867,4.57255426 C11.3897246,3.64525305 10.5626003,2.97375906 9.54460125,2.84585545 L9.54460125,1.91855423 C9.67185114,1.85460243 9.76728855,1.75867472 9.86272597,1.662747 C10.403538,1.88657833 11.0715999,2.04645785 11.3897246,2.04645785 C11.9623491,2.04645785 12.4077237,1.5987952 12.4077237,1.02322893 C12.4077237,0.447662655 11.9623491,4.50555105e-14 11.3897246,4.50555105e-14 C11.0715999,4.50555105e-14 10.3081006,0.15987952 9.76728855,0.415686751 C9.70366361,0.383710847 9.67185114,0.319759039 9.60822619,0.287783135 C9.32191395,0.127903616 8.97197676,0.127903616 8.68566452,0.287783135 C8.62203958,0.319759039 8.55841463,0.383710847 8.49478969,0.447662655 C7.95397768,0.191855423 7.15866589,4.50555105e-14 6.8087287,4.50555105e-14 C6.23610421,4.50555105e-14 5.79072961,0.447662655 5.79072961,1.02322893 C5.79072961,1.5987952 6.23610421,2.04645785 6.8087287,2.04645785 C7.12685342,2.04645785 7.85854026,1.88657833 8.39935228,1.6307711 C8.46297722,1.72669881 8.52660216,1.79065062 8.62203958,1.85460243 L8.62203958,2.84585545 C7.66766543,3.00573497 6.87235364,3.67722895 6.45879151,4.57255426 L4.804543,4.57255426 C3.53204413,4.57255426 2.51404505,5.62775909 2.51404505,6.90679525 L2.51404505,9.14510852 L4.86816794,9.14510852 L4.86816794,6.97074705 Z"
                fillRule="nonzero"
              ></path>
              <rect
                fillRule="nonzero"
                x="2.14949132"
                y="8.16806701"
                width="3.00928785"
                height="1.28969479"
                rx="0.429898264"
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const FaucetIcon = (props: IconProps) => <Icon component={IconComponent} {...props} />;

export default FaucetIcon;
